<form class="bucket-form" nz-form [formGroup]="bucketForm" nzLayout="vertical" (ngSubmit)="submitForm()">
    <nz-form-item>
        <nz-form-label nzRequired nzFor="name">Name</nz-form-label>
        <nz-form-control [nzErrorTip]="nameErrorTip">
            <input nz-input name="name" id="name" formControlName="name" placeholder="Name of S3 bucket" />
            <ng-template #nameErrorTip let-control>
                @if (control.hasError('required')) {
                Bucket name is required
                } @else if (control.hasError('pattern')) {
                3-63 characters: lowercase letters, numbers, dots and hyphens, starting and ending
                with a letter or number
                }
            </ng-template>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label nzFor="alias">Alias</nz-form-label>
        <nz-form-control [nzErrorTip]="aliasErrorTip">
            <input nz-input name="alias" id="alias" formControlName="alias" placeholder="Alias for S3 bucket" />
            <ng-template #aliasErrorTip let-control>
                @if (control.hasError('required')) {
                Alias is required
                } @else if (control.hasError('maxlength')) {
                Alias must be 64 characters or fewer
                }
            </ng-template>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label nzRequired nzFor="region">Region</nz-form-label>
        <nz-form-control nzErrorTip="Region is required">
            <nz-select id="region" formControlName="region" nzShowSearch nzPlaceHolder="Select region"
                [nzDropdownMatchSelectWidth]="false">
                @for (region of regions; track region.value) {
                <nz-option [nzValue]="region.value" [nzLabel]="region.value + ' — ' + region.label" />
                }
            </nz-select>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label nzFor="description">Description</nz-form-label>
        <nz-form-control nzErrorTip="Description must be 255 characters or fewer">
            <input nz-input name="description" id="description" formControlName="description" placeholder="Description of S3 bucket or its contents" />
        </nz-form-control>
    </nz-form-item>

    @if(!hideButtons()){
        <nz-form-item>
            <nz-form-control>
                <button nz-button nzType="primary" [nzLoading]="isSubmitting()">
                    <nz-icon [nzType]="activeBucket() ? 'save' : 'plus'" />
                    {{ activeBucket() ? 'Save' : 'Add' }}
                </button>
            </nz-form-control>
        </nz-form-item>
        @if (activeBucket()) {
        <nz-form-item>
            <nz-form-control>
                <button nz-button type="button" [disabled]="isSubmitting()" (click)="cancelEdit()">
                    Cancel
                </button>
            </nz-form-control>
        </nz-form-item>
    }

    }
</form>